import {connect} from "react-redux";
import get from "lodash/get";
import {useTranslation} from 'react-i18next';

const hashCode = (str) => {
    let hash = 0, i, chr;
    if (!str || str.length === 0) return hash;
    for (i = 0; i < str.length; i++) {
        chr = str.charCodeAt(i);
        hash = ((hash << 5) - hash) + chr;

    }
    return hash;
};

const MessageName = ({message, nextMessage, userTeam}) => {
    const {t} = useTranslation();

    if (!message.profile_id) {
        if (message.profile_id === nextMessage?.profile_id && nextMessage?.direction !== 2) {
            return <div className="i-chats-dialogue-content-message-name">{t('components.message_name.bot', 'Your Bot')}</div>
        }
        return <></>;
    }
    if(message.profile_id !== nextMessage?.profile_id) {
        const user =  userTeam?.filter(({profile}) => message.profile_id === profile.id)[0];
        if (user) {
            const hash = hashCode(get(user, 'profile.user.email'));
            const number = Math.abs(hash % 16);

            return <div className={`i-chats-dialogue-content-message-name i-chats-dialogue-content-message-name-color-${number}`}>
                {get(user, 'profile.user.username')}
            </div>
        }
        return <></>;
    }

    return <></>;
}

const mapStateToProps = state => ({
    userTeam: state.Shops.activeShopAdministrators,
});


export default connect(mapStateToProps)(MessageName);